<script>
import { useAttrSelector } from '../../core/use-attr-selector/use-attr-selector.js';
import { findSingle, isElement } from '../../utils/dom/index.js';

export default {
  name: 'BaseComponent',
  rootEl: undefined,
  $attrSelector: undefined,
  inject: {
    $parentInstance: { default: undefined },
  },
  computed: {
    $id () {
      return this.$attrs.id || this.uid;
    },
    $inProps () {
      const nodePropKeys = Object.keys(this.$.vnode?.props || {});
      return Object.fromEntries(Object.entries(this.$props).filter(([k])=> nodePropKeys?.includes(k)));
    },
  },
  beforeCreate () {
    this.$attrSelector = useAttrSelector();
    // may needt do some replacing here from 'pc' => 'pv_id_'?
    this.uid = this.$attrs.id || useAttrSelector();
  },
  created () {
  },
  beforeMount () {
    // #deprecated -not Vue 3, nor composition API friendly.
    this.rootEl = findSingle(
      isElement(this.$el) ? this.$el : this.$el?.parentElement,
      `[${this.$attrSelector}]`
    );
  },
  methods: { },
};
</script>
